import BaseService from '@root/core/class/BaseService';
import { IPagination } from '../../../Sellers/Product/interfaces'

class buskStockWarehouseService extends BaseService {
  public getListStock = (
    page: number,
    fromDt?: string,
    toDt?: string,
    filter?: string,
    input?: string,
    sort?: boolean,
    idStock?: number,
  ) => {
    let inputUse = !!input ? (input.replaceAll("%","%25")).replaceAll("#","%23") : "" 
    let url = `/stock-warehouses/${idStock}/stocks?page=${page}&limit=10` + 
              (!!inputUse  ? '&search=' + `${inputUse}` : '&search=') +
              (!!fromDt ? '&fromDt=' + `${fromDt}`: '&fromDt=') +
              (!!toDt ? '&toDt=' + toDt : '&toDt=') +
              (!!filter ? '&searchBy=' + `${filter}` : '&searchBy=') +
              (!!sort ? '&sortBy=updated_at:DESC' : '&sortBy=updated_at:ASC')
    return this.get(
      url
    );
  };
  // api for export excel of list stock of warehouse comment behind is while filter
  public exportExcelStockOfWarehouse= ({
    fieldSearch,
    productName,
    sort,
    fromDt,
    toDt,
  }: IPagination,idStock:number) => {
    let fieldSearchUse = !!fieldSearch ? (fieldSearch.replaceAll("%","%25")).replaceAll("#","%23") : "" 

    let url = `/stock-warehouses/${idStock}/stocks/export?`;
    url +=   ((!!productName  &&
      !!fieldSearchUse) ?`&searchBy=`+productName + `&search=` + fieldSearchUse:'&searchBy=&search=')
      + (!!fromDt ? `&fromDt=${fromDt}` : '&fromDt=')
      + (!!toDt ? `&toDt=${toDt}` : '&toDt=')
      + (sort ? `&sortBy=updated_at:DESC` : `&sortBy=updated_at:ASC` );
    // url = (!!productName &&
    //       !!fieldSearch) || !!sort || !!fromDt || !!toDt ? url + '?' : url;
    // url +=   ((!!productName  &&
    //           !!fieldSearch) ?`&searchBy=`+productName + `&search=` + `fieldSearch`:'&searchBy=&search=')
    //           + (!!fromDt ? `&fromDt=${fromDt}` : '&fromDt=')
    //           + (!!toDt ? `&toDt=${toDt}` : '&toDt=')
    //           + (sort ? `&sortBy=updated_at:ASC` : `&sortBy=updated_at:DESC` );
    let urlUse = url.replace('?&','?')
    return this.post(
      urlUse,
      {},
      {
        responseType: "blob",
      }
    );
  };

  public exportStockOfWarehouseExcellById = (
    {
      fieldSearch,
      productName,
      sort,
      fromDt,
      toDt,
      listId
    }: IPagination
    ,id:number) => {
      let fieldSearchUse = !!fieldSearch ? (fieldSearch.replaceAll("%","%25")).replaceAll("#","%23") : "" 

      let url = `/stock-warehouses/${id}/stocks/export?`;
      url +=  ((!!productName  &&
            !!fieldSearchUse) ?`&searchBy=`+productName + `&search=` + fieldSearchUse:'&searchBy=&search=')
            + (!!fromDt ? `&fromDt=${fromDt}` : '&fromDt=')
            + (!!toDt ? `&toDt=${toDt}` : '&toDt=')
            + (sort ? `&sortBy=updated_at:DESC` : `&sortBy=updated_at:ASC` );
      let urlUse = url.replace('?&','?')

    return this.post(
      urlUse,
      {
        ids: listId
      },
      {
        responseType: 'blob'
      }
    );
  };

  //api get detail stock 
  public getDetailStock = (warehouseId: number,stockId: number) =>{
    return this.get(`/stock-warehouses/${warehouseId}/stocks/${stockId}`);
  }

  public getPaginationOrder = (warehouseId: Number , stockId: number,productId: number, page:number, sort: boolean, ) =>{
    let url = `/stock-warehouses/${warehouseId}/stocks/${stockId}/orders/${productId}?page=${page}&limit=10` + (!!sort ? "&sortBy=updated_at:ASC" : "")
    return this.get(url)
  }

  public getPaginationOrderFake = (warehouseId: Number , stockId: number, page:number, sort: boolean) =>{
        let data = [...Array(5)].map((item,index) => (
            {
                ...item,...{
                quantityImport: [1,1,3,5,6,7,8][Math.ceil(Math.random() * 6)],
                quantityRemain: 1,
                updated_at: new Date().getTime() +  [0,1000,10000,3000][Math.ceil(Math.random() * 3)],
                }
            }
        ))
        let dataUse = data.map(item =>({
          ...item,...{
            quantityRelease: item.quantityImport == 1 ? 0 :item.quantityImport -1,
          }
        }))
        return {data:dataUse,count:5}
  }

  public getListOrder = (
    page: number,
    idWarehouse: number,
    idStocks: number,
    sort?: boolean,
  ) => {
    let url = `/stock-warehouses/${idWarehouse}/stocks/${idStocks}/orders?page=${page}&limit=10` + 
              (!sort ? '&sortBy=updated_at:DESC' : '&sortBy=updated_at:ASC')
    return this.get(
      url
    );
  };

}

export default new buskStockWarehouseService('/api/v1/admin', true);
